import React, { FC } from "react";
import { FaBoxArchive } from "react-icons/fa6";

import { SettingsConfirmModal } from "../../../components/modal/SettingsConfirmModal";
import { WorkModel } from "../../../factories/works/models/work.model";

type Props = {
  isOpen: boolean;
  selectedWorks: WorkModel[];
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
  isLoading?: boolean;
};

export const WorksArchiveConfirmModal: FC<Props> = ({
  isOpen,
  selectedWorks,
  onClose,
  onConfirm,
  isLoading,
}) => {
  if (!isOpen) return null;

  const isMultiple = selectedWorks.length > 1;

  return (
    <SettingsConfirmModal
      onClose={onClose}
      onConfirm={() => void onConfirm()}
      icon={<FaBoxArchive size={18} />}
      title={isMultiple ? "Archive selected works?" : "Archive selected work?"}
      description={
        isMultiple
          ? "Selected works will be moved to archive."
          : "Selected work will be moved to archive."
      }
      confirmText={"Archive"}
      variant={"primary"}
      isLoading={isLoading}
    />
  );
};
